/**
 * Bill Credits Container
 */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import billCreditActions from './actions';
import BillCredits from '../../Components/BillCredits/BillCredits';
import {
  loadingSelector,
  billCreditsSelector,
  countSelector,
} from './selectors';

const { getBillCredits } = billCreditActions;

/**
 * Properties to be provided to the bill credits component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  billCredits: billCreditsSelector(state),
  loading: loadingSelector(state),
  count: countSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch bill credits actions
 */
const mapDispatchToProps = (dispatch) => ({
  getBillCredits: (user, params) => dispatch(getBillCredits(user, params)),
});

/**
 * Connects state to the bill credits component
 *
 * @param {object} mapStateToProps data object to become props for the Bill Credits component
 * @param {object} mapDispatchToProps Bill Credits actions to be dispatched to reducer
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BillCredits),
);
